import { useState, useEffect } from 'react';
import { SalesStageService, SalesStageMapping } from '../services/salesStageService';

/**
 * Hook to get dynamic sales stage mapping with caching
 */
export const useSalesStageMapping = (stage: string) => {
  const [mapping, setMapping] = useState<SalesStageMapping>({
    label: stage,
    description: 'Ładowanie...'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const loadMapping = async () => {
      try {
        const result = await SalesStageService.getSalesStageMapping(stage);
        if (mounted) {
          setMapping(result);
          setLoading(false);
        }
      } catch (error) {
        if (mounted) {
          setMapping({
            label: stage,
            description: 'Nieznany etap sprzedaży'
          });
          setLoading(false);
        }
      }
    };

    loadMapping();

    return () => {
      mounted = false;
    };
  }, [stage]);

  return { mapping, loading };
};

/**
 * Hook to preload multiple sales stage mappings
 */
export const useSalesStageMultipleMapping = (stages: string[]) => {
  const [mappings, setMappings] = useState<Record<string, SalesStageMapping>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const loadMappings = async () => {
      const result: Record<string, SalesStageMapping> = {};
      
      for (const stage of stages) {
        try {
          result[stage] = await SalesStageService.getSalesStageMapping(stage);
        } catch (error) {
          result[stage] = {
            label: stage,
            description: 'Nieznany etap sprzedaży'
          };
        }
      }

      if (mounted) {
        setMappings(result);
        setLoading(false);
      }
    };

    if (stages.length > 0) {
      loadMappings();
    } else {
      setLoading(false);
    }

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stages]);

  const getMapping = (stage: string): SalesStageMapping => {
    return mappings[stage] || {
      label: stage,
      description: 'Ładowanie...'
    };
  };

  return { mappings, getMapping, loading };
};